var map = {
	"./bonus_coin_active.png": "fNuW",
	"./bonus_coin_bg.png": "+Vfj",
	"./bonus_coin_next.png": "0QNs",
	"./bonus_coin_reconnect.png": "E05o",
	"./bonus_coin_solid.png": "JLoj",
	"./bonus_coin_wait.png": "j5o3",
	"./bonus_get_icon.png": "w3gx",
	"./coin_title.png": "M2IH"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1PzW";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xbb ^\.\/.*$
// module id = 1PzW
// module chunks = 7